exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value[data-v-7e41cba3]{font-weight:700}", ""]);

// exports
